import type { ResolveRoundAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { StoneFlickingCoreState } from "../types/game-state";
import { isAllInputsReceived } from "../utils/participant-helpers";

export function validateResolveRound(
  state: StoneFlickingCoreState,
  action: ResolveRoundAction,
): ValidationResult {
  if (action.resolverId !== state.hostPlayerId)
    return { valid: false, error: "Only the host can resolve the round" };
  if (state.phase !== "INPUT_PHASE") {
    return { valid: false, error: "Not in input phase" };
  }

  if (!isAllInputsReceived(state)) {
    return {
      valid: false,
      error: "Not all active participants have submitted",
    };
  }

  return { valid: true };
}
